import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';
import { MemberChartComponent } from './features/dashboard/registered-members/edit-registered-members/member-chart/member-chart.component';

const appRoutes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'registered-members/charts/:orgId/:id/:token/:group',
    component: MemberChartComponent
  },
  {
    path: '',
    loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [AuthGuard],
    data: { role: 'responder' }
  },
  {
    path: 'center',
    loadChildren: () => import('./features/center-dashboard/center-dashboard.module').then(m => m.CenterDashboardModule),
    canActivate: [AuthGuard],
    data: { role: 'center' }
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes)
  ],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }
